import AcademyHit from '../academy-hit';
import CommunityHit from '../community-hit';
import DevPortalHit from '../dev-portal-hit';
import HelpCenterHit from '../help-center-hit';
import MarketingSiteHit from '../marketing-site-hit';

import { useTranslation } from '@klv/hooks/useTranslation';

import type { ISearchData } from '../types';

const useSearchData = (): ISearchData[] => {
  const { t } = useTranslation();

  return [
    {
      headline: '',
      indexName: '',
      showCard: false,
    },
    {
      headline: t('helpCenter_templates_search_searchData_helpCenter_headline'),
      hitComponent: HelpCenterHit,
      indexName: 'help_center_articles',
      showCard: true,
    },
    {
      headline: t('helpCenter_templates_search_searchData_community_headline'),
      hitComponent: CommunityHit,
      indexName: 'community_forum_questions',
      showCard: true,
    },
    {
      headline: t('helpCenter_templates_search_searchData_developers_headline'),
      hitComponent: DevPortalHit,
      indexName: 'dev_portal',
      showCard: true,
    },
    {
      headline: t('helpCenter_templates_search_searchData_academy_headline'),
      hitComponent: AcademyHit,
      indexName: 'academy_courses',
      showCard: true,    
    },
    {
      headline: t('helpCenter_templates_search_searchData_marketing_headline'),
      hitComponent: MarketingSiteHit,
      indexName: 'marketing_sites',
      showCard: true,    
    },
  ];
};

export default useSearchData;
